import React, { Fragment } from 'react';
import RutaProtegida from './components/RutaProtegida';
import AppLayout from './components/app';

import Signin from './auth/signin';

import RegistroConvecion from './components/asistentes/registro-convencion'
import DetalleConvencion from './components/asistentes/detalle-convencion'

import { Routes, Route, Navigate } from 'react-router-dom';

const NoAutorizado = () => {
  return <Fragment>
    <div>
      <h1>No tiene los permisos para ver este contenido</h1>
      <p>Laborum labore tempor fugiat dolore minim. Est commodo velit dolore eiusmod dolor. Pariatur occaecat nisi sint officia proident qui tempor. Sint commodo excepteur ullamco eiusmod eu do. Proident veniam aute proident dolor ipsum sit incididunt. Elit commodo est mollit laborum aute officia laborum dolore ex occaecat. Culpa occaecat aute nulla voluptate.</p>
    </div>
  </Fragment>
}

const RutasCMS = () => {
  return (
    <AppLayout>
      <Routes>
        {/* ============== RUTAS INTERNAS DEL CMS ============== */}
        <Route element={<RutaProtegida permisos={[1, 13, 14, 1020]} />}>
          <Route path='/detalle-convencion/:evento/:tps/:folio' element={<DetalleConvencion />} />
        </Route>

        <Route element={<RutaProtegida permisos={[1, 13, 14, 1020]} validarRuta={true} />}>
          <Route path='/registros/:evento/:tps' element={<RegistroConvecion />} />
        </Route>

        {/* ============== RUTA NO EXISTENTE ============== */}
        <Route path="*" element={<Navigate to={'/registros/3/1'} />} />
      </Routes>
    </AppLayout>
  )
}

function App() {
  return (
    <Routes>
      {/* ============== RUTAS PÚBLICAS ============== */}
      <Route path={`${process.env.PUBLIC_URL}/login`} element={<Signin />}/>
      <Route path={`${process.env.PUBLIC_URL}/no-autorizado`} element={<NoAutorizado />}/>
      {/* ============== RUTAS CON PERMISOS ============== */}
      <Route path='*' element={<RutasCMS />} />
    </Routes>
  );
}

export default App;